import axios from 'axios';

// Public quote-link API — completely standalone from the staff/vendor clients.
// No Authorization header, no login redirect on 401. The signed `token` from the
// URL is the identity and is passed in every request body.

const serverURL = process.env.REACT_APP_BASE_URL || 'http://143.110.243.16:4000';

const quoteAxios = axios.create({
	baseURL: serverURL,
	headers: { 'Content-Type': 'application/json' },
});

// Backend responses are { status, message, data }. Unwrap; throw on status:false.
const unwrap = (res: any) => {
	const body = res?.data;
	if (body && body.status === false) {
		const err: any = new Error(body.message || 'Request failed');
		err.apiMessage = body.message;
		err.data = body.data;
		throw err;
	}
	return body?.data;
};

export const getQuoteLinkDetail = async (token: string) =>
	unwrap(await quoteAxios.post('/vendor/quote-link/detail', { token }));

export const saveQuoteLinkDraft = async (token: string, payload: any) =>
	unwrap(await quoteAxios.post('/vendor/quote-link/save-draft', { token, ...payload }));

export const submitQuoteLink = async (token: string, payload: any) =>
	unwrap(await quoteAxios.post('/vendor/quote-link/submit', { token, ...payload }));
